var map = {
	"./card_funFact_bananas.png": 8265,
	"./card_funFact_phone_stack.png": 60278,
	"./card_funFact_rocket.png": 10582,
	"./card_funFact_shoes.png": 92246,
	"./card_funFact_super_speed.png": 11914,
	"./card_funFact_sweat.png": 68345
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72344;